import { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAuth } from '../../hooks/user-auth/use-auth.hook';
import { useAppNav } from '../../routes/layout/components/navigation/hooks/use-app-nav.hook';

const RequireAuth = ({
  navigationId,
  children,
}: {
  children: ReactNode;
  navigationId: string;
}) => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { data, isFetched } = useAppNav();

  useEffect(() => {
    if (!user) {
      navigate('/', { state: { from: location }, replace: true });
    } else if (user.groups && isFetched && data) {
      const hasAccess = data.some((nav) => {
        return nav.id === navigationId;
      });
      if (!hasAccess) {
        navigate('/', { state: { from: location }, replace: true });
      }
    }
  }, [user, location, navigate, data, isFetched, navigationId]);

  return children;
};

export default RequireAuth;
